import React from 'react';
import { isValidIBAN, friendlyFormatIBAN, electronicFormatIBAN } from 'ibantools';

import InputFieldComponent from './InputFieldComponent';

const normalizeIban = value => {
    if (!value) {
        return value;
    }

    return electronicFormatIBAN(value);
};

const formatIban = value => {
    if (!value) {
        return value;
    }

    return friendlyFormatIBAN(value);
};

const isCorrectIban = value => {
    return value.substring(0, 2) === 'NL';
};

const MAX_CHARACTERS_NUMBER = 22;

class IBANInputFieldComponent extends React.Component {
    isIbanValid = value =>
        value && isValidIBAN(value) && isCorrectIban(value)
            ? undefined
            : this.props.i18nFeatureForm.IBAN_INVALID;

    validateMandatory = () => [this.isIbanValid];

    render() {
        const { validate = [] } = this.props;
        return (
            <InputFieldComponent
                {...this.props}
                type="text"
                validate={[...this.validateMandatory(), ...validate]}
                normalize={normalizeIban}
                format={formatIban}
                maxLength={MAX_CHARACTERS_NUMBER}
            />
        );
    }
}

// See proptypes in ./InputFieldComponent.js for global Field props
export default IBANInputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/IBANInputFieldComponent.js